const path = require('path')
const { i18n } = require('./next-i18next.config')

/** @type {import('next').NextConfig} */
const nextConfig = {
	i18n,
	images: {
		remotePatterns: [
			{
				protocol: 'https',
				hostname: 'images.ctfassets.net',
			},
			{
				protocol: 'https',
				hostname: 'downloads.ctfassets.net',
			},
			{
				protocol: 'https',
				hostname: 'assets-cdn.audionetwork.com',
			},
			{
				protocol: 'https',
				hostname: 'prosoundeffects.blob.core.windows.net',
			},
		],
	},
	pageExtensions: ['page.tsx', 'api.ts'],
	basePath: '',
	productionBrowserSourceMaps: true,
	reactStrictMode: true,
	async rewrites() {
		return [
			{
				source: '/welcome',
				destination: '/',
			},
		]
	},
	compiler: {
		styledComponents: {
			ssr: true,
			displayName: true,
		},
	},
	webpack: (config, { isServer }) => {
		if (!isServer) {
			// don't resolve 'fs' module on the client to prevent this error on build --> Error: Can't resolve 'fs'
			config.resolve.fallback = {
				fs: false,
				child_process: false,
			}
		}
		config.resolve.alias.react = path.resolve('./node_modules/react')
		config.resolve.alias['styled-components'] = path.resolve(
			'./node_modules/styled-components'
		)

		config.optimization.splitChunks = {
			cacheGroups: {
				audiolibrary: {
					test: /[\\/]node_modules[\\/](@audio-network[\\/]componentlibrary)[\\/]/,
					name: 'componentLibraryChunk',
					chunks: 'all',
				},
			},
		}

		return config
	},
}

module.exports = nextConfig
